import React, { useContext } from 'react';
import FlexColumn from '../components/shared/FlexColumn';
import CategoryEvents from '../components/edit/CategoryEvents';
import FlexRow from '../components/shared/FlexRow';
import UserContext from '../context/UserContext';
import { API } from '../utils/API';
import { apiConfig, DISTRIBUTION_URL } from '../utils/apiConfig';

export default function About({ token }) {
  const { role } = useContext(UserContext);
  const isAdmin = role === 'admin';
  const [description, setDescription] = React.useState('');
  const [aboutImage, setAboutImage] = React.useState(null);
  const [uploading, setUploading] = React.useState(false);
  const [socialLinks, setSocialLinks] = React.useState({
    tiktok: '',
    facebook: '',
    instagram: '',
    whatsapp: '',
  });

  const getAbout = async () => {
    const res = await API(apiConfig.forumSettings.getAbout, 'GET');
    if (res.status) {
      const about = res.about;
      setDescription(about.text);
      setAboutImage(about.image);
      setSocialLinks(about.social_links);
    }
  };

  const handleSaveAbout = async () => {
    const body = {
      document_type: 'about_text',
      text: description,
      image: aboutImage,
      social_links: socialLinks,
    };
    const res = await API(apiConfig.forumSettings.updateAbout, 'POST', body);
    if (res.status) {
      alert('אודות התעדכן בהצלחה!');
    }
  };

  const uploadFile = async (file) => {
    try {
      const imageCreationTime = new Date().getTime();
      const fileNameCover = `${imageCreationTime}_iamImage.jpg`;

      const presignedUrlResponse = await fetch(`${apiConfig.media.uploadImage}/iamImage/${fileNameCover}/jpeg`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!presignedUrlResponse.ok) {
        throw new Error(`Failed to get pre-signed URL: ${presignedUrlResponse.statusText}`);
      }

      const presignedUrl = await presignedUrlResponse.text();
      const response = await fetch(presignedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'image/jpeg',
        },
        body: file,
      });

      if (!response.ok) {
        throw new Error(`File upload failed: ${response.statusText}`);
      }

      const CoverImage = `iamImage/${fileNameCover}`;
      console.log('[uploadFile] Cover image uploaded successfully!');
      return CoverImage;
    } catch (e) {
      console.error('[IAM] [UploadFile] Error:', e);
      return '';
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    const uploadedUrl = await uploadFile(file);
    setAboutImage(uploadedUrl);
    setUploading(false);
  };

  React.useEffect(() => {
    getAbout();
  }, []);

  return (
    <FlexColumn expand={styles.container}>
      <h2 style={styles.heading}>עמוד אודות</h2>

      <div style={styles.section1}>
        <label style={styles.label}>תיאור:</label>
        <textarea
          value={description}
          style={styles.textArea}
          onChange={(e) => {
            if (isAdmin) {
              setDescription(e.target.value);
            } else {
              alert('No permissions');
            }
          }}
        />
      </div>

      <div style={styles.section}>
        <label style={styles.label}>תמונת מפה:</label>
        {aboutImage && <img src={`${DISTRIBUTION_URL}${aboutImage}`} alt="About" style={styles.imagePreview} />}
        {isAdmin && <input type="file" accept="image/*" onChange={handleFileChange} />}
        {uploading && <p style={{ color: 'gray' }}>Uploading...</p>}
      </div>

      <div style={styles.section}>
        <label style={styles.label}>ליקנים לסושייל: </label>
        {Object.keys(socialLinks).map((key) =>
          key !== '_id' ? (
            <FlexRow key={key} expand={{ alignItems: 'center', marginBottom: 10 }}>
              <label style={styles.socialLabel}>{key}:</label>
              <input
                style={styles.input}
                value={socialLinks[key]}
                onChange={(e) =>
                  setSocialLinks((prev) => ({
                    ...prev,
                    [key]: e.target.value,
                  }))
                }
                disabled={!isAdmin}
              />
            </FlexRow>
          ) : null,
        )}
      </div>

      {isAdmin && (
        <button style={styles.saveButton} onClick={handleSaveAbout}>
          שמירת שינויים
        </button>
      )}
    </FlexColumn>
  );
}

const styles = {
  container: {
    padding: 30,
    paddingBottom: 150,
    maxWidth: 800,
    margin: 'auto',
    fontFamily: 'sans-serif',
  },
  heading: {
    fontSize: 26,
    fontWeight: 700,
    marginBottom: 20,
    borderBottom: '2px solid #ccc',
    paddingBottom: 10,
  },
  section: {
    marginBottom: 30,
  },
  section1: {
    marginBottom: 30,
    width: '100%',
  },
  label: {
    fontWeight: 600,
    marginBottom: 8,
    display: 'block',
    fontSize: 16,
  },
  textArea: {
    width: '100%',
    minHeight: 200,
    padding: 12,
    fontSize: 15,
    borderRadius: 8,
    border: '1px solid #ccc',
    resize: 'vertical',
    direction: 'rtl',
  },
  input: {
    width: 300,
    padding: 8,
    borderRadius: 4,
    border: '1px solid #ccc',
    fontSize: 14,
  },
  socialLabel: {
    width: 100,
    textTransform: 'capitalize',
    fontWeight: 500,
  },
  imagePreview: {
    width: 250,
    borderRadius: 8,
    marginTop: 10,
    marginBottom: 10,
    boxShadow: '0 0 8px rgba(0,0,0,0.1)',
  },
  saveButton: {
    backgroundColor: '#8f3cc0',
    color: '#fff',
    padding: '10px 24px',
    border: 'none',
    borderRadius: 24,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 16,
    marginTop: 10,
  },
};
